module.exports = "https://static.wanderu.com/ui-react/_next/static/media/booking-logo.2b9e0056.svg";